export default __webpack_public_path__ + "static/media/af.79ee200b.svg";